import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getINVOICECONFIGURATIONTableStructure";
export const UPDATE_TABLE_DATA = "updateINVOICECONFIGURATIONTableData";
export const EXPORT_TABLE_DATA = "exportINVOICECONFIGURATIONTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINVOICECONFIGURATIONTableStructure";
export const SET_TABLE_DATA = "setINVOICECONFIGURATIONTableData";
export const SET_TABLE_FILTER = "setINVOICECONFIGURATIONTableFilters";
export const SET_TABLE_PAGE = "setINVOICECONFIGURATIONTablePage";
export const SET_TABLE_PER_PAGE = "setINVOICECONFIGURATIONTablePerPage";
export const SET_TABLE_SORT_BY = "setINVOICECONFIGURATIONTableSortBy";
export const SET_EXPORT_LINK = "setINVOICECONFIGURATIONExportLink";
export const SET_COUNTRIES = "setINVOICECONFIGURATIONCountries";
export const SET_CURRENCIES = "setINVOICECONFIGURATIONCurrencies";
export const SET_INTEGRATION_ID = "setINVOICECONFIGURATIONIntegrationId";

const state = {
  // export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  currencies: [],
  countries: [],
  integration_id: null,
};

const getters = {
  getINVOICECONFIGURATIONTableProperties(state) {
    return state.table_structure.properties;
  },
  getINVOICECONFIGURATIONTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getINVOICECONFIGURATIONCountries(state) {
    return state.countries;
  },
  getINVOICECONFIGURATIONCurrencies(state) {
    return state.currencies;
  },
  getINVOICECONFIGURATIONTableState(state) {
    return state.table_state;
  },
  getINVOICECONFIGURATIONTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINVOICECONFIGURATIONTableFilters(state) {
    return state.table_structure.filters;
  },

  getINVOICECONFIGURATIONTableData(state) {
    return state.table_data.data;
  },

  getINVOICECONFIGURATIONExportUrl(state) {
    return state.export_link;
  },
  getINVOICECONFIGURATIONIntegrationId(state) {
    return state.integration_id;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/validations/datahub/invoice_configurations", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/validations/datahub/invoice_configurations/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/validations/datahub/invoice_configurations/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
  [SET_CURRENCIES](state, currencies) {
    state.currencies = currencies;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_INTEGRATION_ID](state, id) {
    state.integration_id = id;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
